import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/agency-modal.svg'
import _imports_1 from './assets/user-photo.png'


const _withScopeId = n => (_pushScopeId("data-v-410df888"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "popup-create-agency-show" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-block" }, [
  /*#__PURE__*/_createElementVNode("h6", null, "You can now switch to Agency Profile"),
  /*#__PURE__*/_createElementVNode("p", null, "Agency Profile gives you the opportunity to build a community of influencers, apply to campaigns together and double your chances for success.")
], -1))
const _hoisted_4 = { class: "p-d-flex p-justify-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dialog-content" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "agency-modal-image"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-blocks" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "More campaigns, more opportunities"),
    /*#__PURE__*/_createElementVNode("p", null, "With an agency account you can invite other influencers and apply to campaigns together. You can get an access to the Agency statistics and more.")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-blocks" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "Build a community"),
    /*#__PURE__*/_createElementVNode("p", null, "Create a community of influencers that have the same interests and chase opportunities together.")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "agency-reference-block" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "AGENCY member reference"),
    /*#__PURE__*/_createElementVNode("div", { class: "reference" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "user-photo-block" }, [
        /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
        /*#__PURE__*/_createElementVNode("span", { class: "image-span" }, "Yamisuki Rogue Champion")
      ]),
      /*#__PURE__*/_createElementVNode("p", null, "“This was one of the most amazing opportunities I managed to receive in my career as an influencer. It doubled my regular income and got me the contracts I was looking for”")
    ])
  ])
], -1))
const _hoisted_6 = { class: "buttons-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (!_ctx.agencyCreated && _ctx.dismissAgencyV !== 'dismiss')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "button-show",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.learnMore && _ctx.learnMore(...args)))
            }, "SWITCH / "),
            _createElementVNode("div", {
              class: "button-show",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.dismissAgency && _ctx.dismissAgency(...args)))
            }, " DISMISS")
          ])
        ]),
        _createVNode(_component_Dialog, {
          header: "Learn more about becoming an Agency",
          visible: _ctx.showModalCreate,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModalCreate) = $event)),
          style: { 'min-width': '50vw' }
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                class: "apply-button",
                label: "I WANT TO BECOME AN AGENCY",
                onClick: _ctx.iWantToBecomeAnAgency
              }, null, 8, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}